<template>
  <div class="mb-5 pt-0 mt-0">
    <div class="main-title mb-2 align-with-table">Draft invoices</div>
    <div v-if="deleteDraftErrorMessage">
      <div class="alert-container mt-2">
        <div class="fade-in-out alert alert-error" >
          <div><strong>{{deleteDraftErrorMessage}}</strong></div>
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <vue-good-table
          :columns="draftColumns"
          :rows="draftRows"
          class="table-word-wrap"
          :pagination-options="{enabled: this.invoiceDraftsPaginationEnabled, ...paginationOptions}"
          v-if="invoiceDraftRecords && invoiceDraftRecords.length > 0"
      >
        <div slot="emptystate">{{ noRecordsMessage }}</div>
        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'actions'">
                                <div class="content row-content">
                                  <span
                                      class="solution-link"
                                      @click="loadDraftRecordById(props.row.id)"
                                  >Edit</span> |
                                  <span
                                      class="delete-link"
                                      @click="deleteDraftById(props.row.id)"
                                  >Delete</span>
                                </div>
                            </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
import swal from "sweetalert2";
import {mapActions, mapGetters, mapMutations} from "vuex";
import { VueGoodTable } from "vue-good-table";
import VGT_COLUMNS from "@/store/vgtColumns";
import VGT_PAGINATION_OPTIONS from "../../store/vgtPaginationOptions";

export default {
  name: "UserInvoiceDrafts",
  components: {VueGoodTable},
  data() {
    return {
      draftRows :[],
      draftColumns: VGT_COLUMNS.INVOICES_DRAFTS_COLUMNS,
      paginationOptions: VGT_PAGINATION_OPTIONS.INVOICES_DRAFTS_PAGINATION_OPTIONS,
      noRecordsMessage: "No draft records exist.",
    }
  },
  created() {
    this.loadDraftRows()
  },
  computed: {
    ...mapGetters(["invoiceDraftRecords","deleteDraftErrorMessage"]),
    invoiceDraftsPaginationEnabled() {
      return this.invoiceDraftRecords && this.invoiceDraftRecords.length > 5
    },
  },
  methods: {
    ...mapMutations(["setIsFormDataLoaded","setDeleteDraftErrorMessage","setIsContinueDraftClicked","setIsLoading"]),
    ...mapActions(["fetchInvoiceDraftRecords","deleteInvoiceDraftById"]),
    loadDraftRows(){
      this.draftRows = JSON.parse(JSON.stringify(this.invoiceDraftRecords))
      this.draftRows = this.draftRows.map((draft)=>{
        draft.supplierName = this.isValidString(draft.supplierName) ? draft.supplierName : 'N/A'
        draft.poNumber = this.isValidString(draft.poNumber) ? draft.poNumber : 'N/A'
          return {...draft,formType : CONSTANTS.INVOICE_FORM_TYPE.find(form => form.formCode === draft.formType).formDisplayText}
      })
    },
    deleteDraftById(id) {
      this.setDeleteDraftErrorMessage('')
      swal.fire({
        title: 'Delete draft',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "flat-btn primary-blue-btn btn mb-1",
          cancelButton: "flat-btn gray-btn cancel-btn btn mb-1"
        },
        reverseButtons: true,
        buttonsStyling: false
      }).then((result) => {
        if(result.isConfirmed) {
          swal.showLoading()
          this.deleteInvoiceDraftById(id).then(() => {
          }).finally(async () => {
            this.setIsLoading(true)
            await this.fetchInvoiceDraftRecords()
            this.loadDraftRows()
            swal.hideLoading()
            this.setIsLoading(false);
          })
        }
      })
    },
    loadDraftRecordById(id) {

      if (this.invoiceDraftRecords && this.invoiceDraftRecords.length > 0) {
        this.setIsFormDataLoaded(true)
        this.setIsContinueDraftClicked(false)
        //Also check which type of form,i.e; either PO or NON PO.
        let formType = this.invoiceDraftRecords.find((draftCase) => id === draftCase.id).formType
        if (formType === CONSTANTS.PO_BASED_API_FORM_TYPE) {
          this.$router.push({name: CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM, params: {id}})
        } else if (formType === CONSTANTS.NON_PO_BASED_API_FORM_TYPE) {
          this.$router.push({name: CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM, params: {id}})
        } else if (formType === CONSTANTS.ONE_TIME_SUPPLIER_API_FORM_TYPE) {
          this.$router.push({name: CONSTANTS.DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM, params: {id}})
        }
        this.$hhMixpanel.trackEvent("Supplier central - Invoice draft selected", { formType : formType });

      }
    },
    isValidString(data){
        return data && data.length > 0
    }
  },
}
</script>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>